export default __webpack_public_path__ + "static/media/V365_CoC.58a695fb.pdf";